import BookingDetailsPage from '../../shared/booking/BookingDetailsPage';
import { activityRefund } from './data';
import SightseeingSummary from './SightseeingSummary';

export default function SightseeingBookingDetails() {
  return (
    <BookingDetailsPage
      module="sightseeing"
      Summary={SightseeingSummary}
      refLabel="Voucher no."
      refund={activityRefund}
      policy={[
        'Free cancellation up to 24 hours before the activity start time.',
        'Cancellations within 24 hours and no-shows are non-refundable.',
        'Weather-related cancellations by the operator are fully refunded.',
      ]}
    />
  );
}
